import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from './store'
import App from './App'
import './index.css'
import { ThemeProvider } from '@material-tailwind/react'
import { ToastContainer } from 'react-toastify'
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n.config.ts';
import 'react-toastify/dist/ReactToastify.css'
import KeycloakProvider from './providers/KeycloakProvider.tsx'
// Add global error handlers
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <I18nextProvider i18n={i18n}>
      <Provider store={store}>
      <KeycloakProvider>
        <ThemeProvider>
          <App />
          <ToastContainer theme="colored" />
        </ThemeProvider>
        </KeycloakProvider>
      </Provider>
    </I18nextProvider>
)
